import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";

const CardHolderWebsiteOverview = ({ data }) => {
  const {
    cardholder_website_would_you_like_cardholder_website,
    cardholder_website_web_language,
    cardholder_website_web_language_other,
    cardholder_website_url,
  } = data["3_3"];

  const languageValue = [
    ...(cardholder_website_web_language ?? [])
      .filter((l) => l?.length && l !== "other")
      .map(toTitleCase),
    ...(cardholder_website_web_language?.includes("other") &&
    cardholder_website_web_language_other?.length
      ? [`Other (${toTitleCase(cardholder_website_web_language_other)})`]
      : []),
  ].join(", ");

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="Cardholder Website (C-Holder Web)" />
        </div>
        <ReviewAttribute
          label="Would you like Cardholder Website?"
          value={
            cardholder_website_would_you_like_cardholder_website?.length
              ? toTitleCase(cardholder_website_would_you_like_cardholder_website)
              : "-"
          }
        />
        <ReviewAttribute
          label="C-Holder Web Language"
          value={languageValue || "-"}
        />
        <ReviewAttribute
          label="Cardholder Website URL"
          value={cardholder_website_url?.length ? cardholder_website_url : "-"}
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default CardHolderWebsiteOverview;
